import React from 'react'
import styled from 'styled-components';
import { useMediaQuery } from '../../hooks/mediaquery';
import {b} from "../../styles/variables"
import { useDispatch,useSelector } from 'react-redux';
import { getVendors } from '../../redux/feature/vendorSlice';
import { useEffect } from 'react';
import { useState } from 'react';
import VendorCard from '../VendorCard';

function Vendors() {
  const auth=useSelector((state) => state.auth)
    const dispatch = useDispatch()
    const {vendorList} = useSelector((state)=>state.vendors)
    const vendors = Object.values(vendorList)
    const location = auth.creds.userlocation
    
    useEffect(() => {
      dispatch(getVendors(location))
    }, [location]);
  
  return (   
  <MainContainer>
    <CardsContainer>
      {vendors.map(vendor => {
        return(
          <React.Fragment key={vendor.vendor_id}>
            <VendorCard vendor={vendor}/>
          </React.Fragment>
        )
      })}
    </CardsContainer>
  </MainContainer>
  )
}

export default Vendors

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 2.4rem;
  overflow-y: auto;

  @media ${b.mobile}{
    padding: 1.6rem;
  }
`

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding-bottom: 4rem;

  @media ${b.mobile}{
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 1.2rem;
  }
`
